export const ShippingTypes = {
    Pickup: 'Pickup',
    Delivery: 'Delivery'
}

export const ShippingTypesList = [
    { label: ShippingTypes.Pickup, value: ShippingTypes.Pickup },
    { label: ShippingTypes.Delivery, value: ShippingTypes.Delivery },
]